import React, {useState, useEffect, useRef} from "react";
import {Form, Button, Table, Col, Row, Modal, FormControl} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import '../../App.css';
import { adjustStock } from "../../api/api";
import {useProducts} from "../../ProductContext";
import {useCategories} from "../../CategoryContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit, faEye, faTrash} from "@fortawesome/free-solid-svg-icons";
import Pagination from "react-bootstrap/Pagination";
// import {fetchUnitsOfMeasure} from "../../api/api";

function Product() {
    const { products, fetchAllProducts, totalPages, unitsOfMeasure, addUnitOfMeasure, fetchAllUnitsOfMeasure,
        updateUnitOfMeasureContext, addProduct, updateProduct, deleteProduct, updateProductsForEditedCategory,
        updateProductsForDeletedCategory, deleteUnitOfMeasureContext } = useProducts();
    const { categories, addCategory, updateCategory, deleteCategory } = useCategories();
    const [showModal, setShowModal] = useState(false);
    const [newProduct, setNewProduct] = useState({
        product_name: '',
        description: '',
        cost_price: 0,
        stock: 0,
        retail_price: '',
        wholesale_price: '',
        category: '',
        base_unit: '',
        has_alternative_units: false,
        alternative_units: [], // array to hold alternative units
        reorder_level: '',
        is_vat_applicable: true, //default to true
        is_active: true,
        quantity_discount_threshold: '',
        quantity_discount_amount: '',
        quantity_discount_is_active: false,
    });
    const [showUnitModal, setShowUnitModal] = useState(false);
    const [newUnit, setNewUnit] = useState({
        name: '',
        abbreviation: '',
        conversion_factor: 1,
        base_unit: '',
    });
    const [showUnitList, setShowUnitList] = useState(false);
    const [currentUnit, setCurrentUnit] = useState(null);
    // const [showAddUnitModal, setShowAddUnitModal] = useState(false);
    const [showEditUnitModal, setShowEditUnitModal] = useState(false);

    const [showEditModal, setShowEditModal] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [newCategory, setNewCategory] = useState({ category_name: '', description: ''});
    const [showCategoryList, setShowCategoryList] = useState(false);
    const [editCategory, setEditCategory] = useState(null);
    const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState(''); //search term for products
    const [selectedCategoryFilter, setSelectedCategoryFilter] = useState(''); //selected category filter
    const [stockPositiveFilter, setStockPositiveFilter] = useState(false);
    // for manual stock adjustment
    const [showAdjustModal, setShowAdjustModal] = useState(false);
    const [adjustProduct, setAdjustProduct] = useState(null);
    const [adjustData, setAdjustData] = useState({
        quantity: '',
        direction: 'IN',
        reason: '',
    });

    const navigate = useNavigate();

    // pagination
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        fetchAllProducts(currentPage, searchTerm, selectedCategoryFilter, stockPositiveFilter);
    }, [fetchAllProducts, currentPage, searchTerm, selectedCategoryFilter, stockPositiveFilter]);

    // pagination window (match purchase.js style)
    const maxLinks = 5;
    let startLink = Math.max(currentPage - 2, 1);
    let endLink = Math.min(startLink + maxLinks - 1, totalPages);

    if (endLink > totalPages) {
        endLink = totalPages;
        startLink = Math.max(endLink - (maxLinks - 1), 1);
    }

    const pageNumbersToShow = [];
    for (let i = startLink; i <= endLink; i++) {
        pageNumbersToShow.push(i);
    }

    //create a ref to each modal (for closing when clicked outside)
    const modalRef = useRef();
    const editModalRef = useRef();
    const categoryModalRef = useRef();
    const categoryListModalRef = useRef();
    const editCategoryModalRef = useRef();

    const handleBack = () => {
        navigate(-1);
    };


    //function to handle click outside of modal
    const handleClickOutside = (e, ref, closeModalFunction) => {
        if (ref.current && !ref.current.contains(e.target)) {
            closeModalFunction();
        }
    }

    // useEffect to handle click event outside of modal
    useEffect(() => {
        const handleOutsideClick = (e) => {
            handleClickOutside(e, modalRef, () => setShowModal(false));
            handleClickOutside(e, editModalRef, () => setShowEditModal(false));
            handleClickOutside(e, categoryModalRef, () => setShowCategoryModal(false));
            handleClickOutside(e, categoryListModalRef, () => setShowCategoryList(false));
            handleClickOutside(e, editCategoryModalRef, () => setShowEditCategoryModal(false));
        // add similar checks for other modals if needed
        };

        // add event listener on mount
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            // clean up event listener on unmounting
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    // additional functions to add, update and delete products would go here
    // function to format prices
    const formatPrice = (price) => Number(price).toFixed(2);

    const handleHideModal = () => setShowModal(false);

    const handleInputChange = (e) => {
        const {name, value, type, checked} = e.target;

        setNewProduct(prevState => {
            const updatedProduct = {
                ...prevState,
                [name]: type === 'checkbox' ? checked : value
            };

            // if base price changed, recalculate unit prices
            if (['cost_price', 'retail_price', 'wholesale_price'].includes(name)) {
                updatedProduct.alternative_units = updatedProduct.alternative_units.map(unit => {
                    const conversionFactor = parseFloat(unit.conversion_factor);
                    const costPrice = parseFloat(updatedProduct.cost_price);
                    const retailPrice = parseFloat(updatedProduct.retail_price);
                    const wholesalePrice = parseFloat(updatedProduct.wholesale_price);

                    if (!isNaN(conversionFactor) && conversionFactor > 0) {
                        unit.unit_cost_price = !isNaN(costPrice) ? (costPrice * conversionFactor).toFixed(2) : '';
                        unit.unit_price = !isNaN(retailPrice) ? (retailPrice * conversionFactor).toFixed(2) : '';
                        unit.unit_wholesale_price = !isNaN(wholesalePrice) ? (wholesalePrice * conversionFactor).toFixed(2) : '';
                    } else {
                        // clear prices if conversion factor is invalid
                        unit.unit_cost_price = '';
                        unit.unit_price = '';
                        unit.unit_wholesale_price = '';
                    }

                    return unit;
                });
            }
            return updatedProduct;
        });
    }

    // function to add a new unit of measure, update & delete
    const handleAddUnit = async (e) => {
        e.preventDefault();
        try {
            await addUnitOfMeasure(newUnit);
            setNewUnit({name: '', abbreviation: '', conversion_factor: 1, base_unit: ''});
            setShowUnitModal(false);
            fetchAllUnitsOfMeasure();
        } catch (error) {
            console.error('Error adding unit of measure', error);
        }
    };

    // function to handle edit button click, takes unit as parameter, sets it as the currentUnit and opens the edit modal
    const handleEditUnit = (unit) => {
        setCurrentUnit({
            id: unit.id,
            name: unit.name,
            abbreviation: unit.abbreviation,
            conversion_factor: unit.conversion_factor,
            base_unit: unit.base_unit ? unit.base_unit : '',
        });
        setShowEditUnitModal(true);
    };

    const handleUpdateUnit = async (e) => {
        e.preventDefault()
        try {
            await updateUnitOfMeasureContext(currentUnit.id, currentUnit);
            setShowEditUnitModal(false);
        } catch (error) {
            console.error('Error updating unit of measure', error);
        }
    };

    const handleDeleteUnit = async (unitId) => {
        if (window.confirm('Are you sure you want to delete this unit of measure?')) {
            try {
                await deleteUnitOfMeasureContext(unitId);
            } catch (error) {
                console.error('Error deleting unit of measure', error);
            }
        }
    };

    // similar to handleInputChange but for the edit form
    const handleEditInputChange = (e) => {
        const {name, value, type, checked} = e.target;

        setCurrentProduct(prevState => {
            const updatedProduct = {
                ...prevState,
                [name]: type === 'checkbox' ? checked : value,
            };

            // if base price changed, recalculate unit prices
            if (['cost_price', 'retail_price', 'wholesale_price'].includes(name)) {
                updatedProduct.alternative_units = updatedProduct.alternative_units.map(unit => {
                    const conversionFactor = parseFloat(unit.conversion_factor);
                    const costPrice = parseFloat(updatedProduct.cost_price);
                    const retailPrice = parseFloat(updatedProduct.retail_price);
                    const wholesalePrice = parseFloat(updatedProduct.wholesale_price);

                    if (!isNaN(conversionFactor) && conversionFactor > 0) {
                        unit.unit_cost_price = !isNaN(costPrice) ? (costPrice * conversionFactor).toFixed(2) : '';
                        unit.unit_price = !isNaN(retailPrice) ? (retailPrice * conversionFactor).toFixed(2) : '';
                        unit.unit_wholesale_price = !isNaN(wholesalePrice) ? (wholesalePrice * conversionFactor).toFixed(2) : '';
                    } else {
                        // clear prices if conversion factor is invalid
                        unit.unit_cost_price = '';
                        unit.unit_price = '';
                        unit.unit_wholesale_price = '';
                    }

                    return unit;
                });
            }
            return updatedProduct;
        });
    }

    const handleShowEditModal = (product) => {
        setCurrentProduct({
            ...product,
            category: product.category? product.category.id : '',
            base_unit: product.base_unit? product.base_unit.id : '',
            // base_unit: product.base_unit ? product.base_unit.toString() : '',
            has_alternative_units: product.has_alternative_units || false,
            // alternative_units: product.units || []
            alternative_units: product.units ? product.units.map(unit => ({
                id: unit.id,
                unit: unit.unit ? unit.unit.id : '',  // Assuming unit.unit is the UnitOfMeasure object
                conversion_factor: unit.conversion_factor,
                unit_price: unit.unit_price,
                unit_wholesale_price: unit.unit_wholesale_price,
                unit_cost_price: unit.unit_cost_price,
        })) : [],
        });
        setShowEditModal(true);
    };

    const handleHideEditModal = () => {
        setShowEditModal(false);
    };

    // to format the product data before sending to the server esp alternative units
    const prepareProductData = (product) => {
        // transform alternative_units to units
        const formattedProduct = {
            ...product,
            base_unit_id: product.base_unit || null, // map base_unit to base_unit_id
            quantity_discount_threshold: product.quantity_discount_threshold || 0,
            quantity_discount_amount: product.quantity_discount_amount || 0,
            units: product.alternative_units.map(unit => ({
                unit_id: unit.unit, //'unit' is the ID of the UnitOfMeasure
                conversion_factor: unit.conversion_factor,
                unit_price: unit.unit_price !== '' ? parseFloat(unit.unit_price ): null,
                unit_wholesale_price: unit.unit_wholesale_price !== '' ? parseFloat(unit.unit_wholesale_price) : null,
                unit_cost_price: unit.unit_cost_price !== '' ? parseFloat(unit.unit_cost_price) : null,
            })),
        };
        // remove alternative_units from the formatted product
        delete formattedProduct.alternative_units;
        delete formattedProduct.base_unit; // remove base_unit since we have base_unit_id
        return formattedProduct;
    }

    const handleUpdateProduct = async (e) => {
        e.preventDefault();
        // console.log('zee product is', currentProduct);

        const cost = parseFloat(currentProduct.cost_price);
        const retail = parseFloat(currentProduct.retail_price);
        const wholesale = parseFloat(currentProduct.wholesale_price);

        if (retail < cost || wholesale < cost) {
            alert("Retail and Wholesale prices cannot be lower than the Cost Price");
            return; // block submission
        }

        try {
            const productData = prepareProductData(currentProduct);
            await updateProduct(productData);
            handleHideEditModal(); //hide the modal after successful submission
        } catch (error) {
            console.error('Error updating product', error);
        }
    }

    const handleDeleteProduct = async (productId) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this product?');
        if (confirmDelete) {
            try {
                await deleteProduct(productId);
            } catch (error) {
                console.error('Error deleting product', error);
            }
        }
    };

    // new handle submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log('new product is', newProduct);

        // preventing the setting of selling price below cost price
        // new products should derive cost from purchases, so creation starts at zero cost
        const cost = 0;
        const retail = parseFloat(newProduct.retail_price);
        const wholesale = parseFloat(newProduct.wholesale_price);

        if (retail < cost || wholesale < cost) {
            alert("Retail and Wholesale prices cannot be lower than the Cost Price");
            return; // block submission
        }

        try {
            const productData = {
                ...prepareProductData(newProduct),
                cost_price: 0,
                stock: 0,
            };
            await addProduct(productData);
            // rest the form and close the modal
            setNewProduct({
                product_name: '',
                description: '',
                cost_price: 0,
                stock: 0,
                retail_price: '',
                wholesale_price: '',
                category: '',
                base_unit: '',
                has_alternative_units: false,
                alternative_units: [],
                reorder_level: '',
                is_vat_applicable: true,
                is_active: true,
                quantity_discount_threshold: '',
                quantity_discount_amount: '',
                quantity_discount_is_active: false,
            });
            handleHideModal(); //hide the modal after successful submission
        } catch (error) {
            console.error('Error adding product', error);
        }
    };

    // functions for handling alternative units in the add/edit forms
    const handleAddAlternativeUnit = (isEditMode) => {
        const newUnit = {
            unit: '',
            conversion_factor: '',
            unit_price: '',
            unit_cost_price: '',
            unit_wholesale_price: '',
        };
        if (isEditMode) {
            setCurrentProduct(prevState => ({
                ...prevState,
                alternative_units: [...(prevState.alternative_units || []), newUnit]
            }));
        } else {
            setNewProduct(prevState => ({
                ...prevState,
                alternative_units: [...(prevState.alternative_units || []), newUnit]
            }));
        }
    }

    const handleAlternativeUnitChange = (index, field, value, isEditMode) => {
        const baseProduct = isEditMode ? currentProduct : newProduct;
        const updatedUnits = [...baseProduct.alternative_units];
        updatedUnits[index] = {...updatedUnits[index], [field]: value};

        // calculate prices if unit and conversion factor are set
        const unit = updatedUnits[index];
        const conversionFactor = parseFloat(unit.conversion_factor);
        const costPrice = parseFloat(baseProduct.cost_price);
        const retailPrice = parseFloat(baseProduct.retail_price);
        const wholesalePrice = parseFloat(baseProduct.wholesale_price);

        if (!isNaN(conversionFactor) && conversionFactor > 0) {
            if (!isNaN(costPrice)) {
                unit.unit_cost_price = (costPrice * conversionFactor).toFixed(2);
            }
            if (!isNaN(retailPrice)) {
                unit.unit_price = (retailPrice * conversionFactor).toFixed(2);
            }
            if (!isNaN(wholesalePrice)) {
                unit.unit_wholesale_price = (wholesalePrice * conversionFactor).toFixed(2);
            }
        } else {
            // clear prices if conversion factor is invalid
            unit.unit_cost_price = '';
            unit.unit_price = '';
            unit.unit_wholesale_price = '';
        }

        if (isEditMode) {
            setCurrentProduct(prevState => ({
                ...prevState,
                alternative_units: updatedUnits
            }));
        } else {
            setNewProduct(prevState => ({
                ...prevState,
                alternative_units: updatedUnits
            }));
        }
    };

    const handleRemoveAlternativeUnit = (index, isEditMode) => {
        if (isEditMode) {
            const updatedUnits = [...currentProduct.alternative_units];
            updatedUnits.splice(index, 1);
            setCurrentProduct(prevState => ({
                ...prevState,
                alternative_units: updatedUnits
            }));
        } else {
            const updatedUnits = [...newProduct.alternative_units];
            updatedUnits.splice(index, 1);
            setNewProduct(prevState => ({
                ...prevState,
                alternative_units: updatedUnits
            }));
        }
    };

    const handleAddCategory = async(e) => {
        e.preventDefault();
        try {
            await addCategory(newCategory);
            setShowCategoryModal(false); //hide the modal after successful submission
            setNewCategory({category_name: '', description: ''});
        } catch (error) {
            console.error('Error adding category', error);
        }
    };

    // handle edit button click
    const handleEditCategoryClick = (category) => {
        setEditCategory(category);
        setShowEditCategoryModal(true);
    };

    const handleCloseCategoryModal = () => setShowCategoryModal(false);
    const handleCloseCategoryList = () => setShowCategoryList(false);

    const handleCloseEditCategoryModal = () => setShowEditCategoryModal(false);

    const handleUpdateCategory = async (e) => {
        e.preventDefault();

        // check if editCategory is not null
        if (!editCategory) {
            console.error('No category selected to update');
            return;
        }

        try {
            await updateCategory(editCategory);
            updateProductsForEditedCategory(editCategory);
            setShowEditCategoryModal(false); //hide the modal after successful submission
            setEditCategory(null); //reset the edit category
        } catch (error) {
            console.error('Error updating category', error);
        }
    };

    const handleDeleteCategoryClick = async (categoryId) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this category?');
        if (confirmDelete) {
            try {
                await deleteCategory(categoryId);
                updateProductsForDeletedCategory(categoryId);
            } catch (error) {
                console.error('Error deleting category', error);
            }
        }
    }

    // filter products on search term and category
    // const filteredProducts = (products || []).filter(product => {
    //     const matchesSearchTerm = product.product_name && product.product_name.toLowerCase().includes(searchTerm.toLowerCase());
    //     // const matchesCategory = selectedCategoryFilter ? product.category_name === selectedCategoryFilter : true;
    //     const matchesCategory = selectedCategoryFilter ? product.category && product.category.id === parseInt(selectedCategoryFilter, 10) : true;
    //     return matchesSearchTerm && matchesCategory;
    // });

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // reset to first page
    };

    const handleCategoryFilterChange = (e) => {
        // console.log('Selected Category ID:', e.target.value);
        setSelectedCategoryFilter(e.target.value);
        setCurrentPage(1); // reset to first page
    };

    const handleStockPositiveFilterChange = (e) => {
        setStockPositiveFilter(e.target.checked);
        setCurrentPage(1);
    };

    const handleAdjustStock = async (e) => {
        e.preventDefault();

        // client-side validation for decreasing stock
        if (adjustData.direction === 'OUT' && parseFloat(adjustData.quantity) > parseFloat(adjustProduct.stock)) {
            alert("Error: Decreasing quantity cannot exceed current stock.");
            return;
        }

        try {
            await adjustStock(adjustProduct.id, adjustData);

            setShowAdjustModal(false);
            setAdjustData({ quantity: '', direction: 'IN', reason: '' });
            fetchAllProducts(currentPage, searchTerm, selectedCategoryFilter, stockPositiveFilter);

        } catch (error) {
            console.error("Adjustment failed", error);
        }
    };

    return (
        <>
            <div className="mb-3">
                <Button variant="danger" onClick={handleBack}>Back</Button>
            </div>
            <h1>Products</h1>
            <Row className="mb-3">
                <Col>
                    <Button variant="primary" onClick={() =>setShowModal(true)}>Add New Product</Button>
                </Col>
                <Col>
                    <Button variant="primary" onClick={() => setShowCategoryModal(true)} className="ml-2">
                        Add New Category</Button>
                </Col>
                <Col>
                    <Button variant="primary" onClick={() => setShowCategoryList(true)} className="ml-2">
                        View Categories</Button>
                </Col>
                <Col>
                    <Button variant="primary" onClick={() => setShowUnitList(true)} className="ml-2">
                        View Units</Button>
                </Col>
            </Row>

            <div className="mt-3 mb-3">
                <Row className="mb-3">
                    <Col md={5}>
                        <FormControl placeholder="Search Products..."
                                     value={searchTerm}
                               // onChange={(e) => setSearchTerm(e.target.value)}
                                 onChange={handleSearchChange}
                        />
                    </Col>
                    <Col md={3}>
                        <Form.Control
                            as="select" value={selectedCategoryFilter}
                            // onChange={(e) => setSelectedCategoryFilter(e.target.value)}
                            onChange={handleCategoryFilterChange}
                        >
                            <option value="">All Categories</option>
                            {categories.map(category => (
                                <option key={category.id} value={category.id}>{category.category_name}</option>
                             ))}
                        </Form.Control>
                    </Col>
                    <Col md={2}>
                        <Form.Check
                            type="checkbox"
                            label="Stock > 0"
                            checked={stockPositiveFilter}
                            onChange={handleStockPositiveFilterChange}
                        />
                    </Col>
                    <Col md={2}>
                        <Button variant="primary" onClick={() => setShowUnitModal(true)} className="ml-2">
                                Add Unit Of Measure
                            </Button>
                    </Col>
                </Row>
            </div>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Product Name</th>
                        <th>Cost Price</th>
                        <th>Stock ({products.base_unit ? products.base_unit.abbreviation : 'Units'})</th>
                        <th>Units</th>
                        <th>Retail Price</th>
                        <th>Wholesale Price</th>
                        <th>Category</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map(product => (
                        <tr key={product.id}>
                            <td>
                                <button className="btn btn-link p-0" onClick={() => handleShowEditModal(product)}
                                   style={{textDecoration: 'none', color:'green'}}>
                                {product.product_name || 'Unnamed Product'}
                                 </button>
                            </td>
                            <td>{formatPrice(product.cost_price)}</td>
                            <td>{product.stock}</td>
                            <td>
                                {product.base_unit && (
                                    <div>
                                        <strong>Base Unit:</strong> {product.base_unit.name}
                                    </div>
                                )}
                                {product.units && product.units.length > 0 && (
                                    <div>
                                        <strong>Alternative Units:</strong>
                                        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                            {product.units.map((unit, index) => (
                                                <li key={index}>
                                                    {unit.unit.name} - Conversion Factor: {unit.conversion_factor}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </td>
                            <td>{formatPrice(product.retail_price)}</td>
                            <td>{formatPrice(product.wholesale_price)}</td>
                            <td>{product.category_name || 'No Category'}</td>
                            <td className="d-flex justify-content-between">
                                <Button variant="success" className="mr-1" onClick={() => handleShowEditModal(product)}>
                                    <FontAwesomeIcon icon={faEye} />
                                </Button>
                                <Button variant="danger" onClick={() => handleDeleteProduct(product.id)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/*pagination controls*/}
            <Pagination className="justify-content-center mt-4">
                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                <Pagination.Prev
                    onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                    disabled={currentPage === 1}
                />
                {pageNumbersToShow.map((page) => (
                    <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => handlePageChange(page)}
                    >
                        {page}
                    </Pagination.Item>
                ))}
                <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                />
                <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                />
            </Pagination>

            {/*stock adjustment modal*/}
            <Modal show={showAdjustModal} onHide={() => setShowAdjustModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Adjust Stock</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {adjustProduct && (
                        <Form onSubmit={handleAdjustStock}>
                            <p><strong>{adjustProduct.product_name}</strong></p>
                            <p>Current Stock: {adjustProduct.stock}</p>

                            <Form.Group>
                                <Form.Label>Direction</Form.Label>
                                <Form.Select
                                    value={adjustData.direction}
                                    onChange={(e) => setAdjustData({ ...adjustData, direction: e.target.value })}
                                    >
                                    <option value="IN">Increase</option>
                                    <option value="OUT">Decrease</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mt-2">
                                <Form.Label>Quantity</Form.Label>
                                <Form.Control
                                    type="number"
                                    required
                                    value={adjustData.quantity}
                                    onChange={(e) => setAdjustData({ ...adjustData, quantity: e.target.value })}
                                    max={adjustData.direction === 'OUT' ? adjustProduct.stock : undefined}
                                    min="0.01"
                                    step="0.01"
                                />
                            </Form.Group>

                            <Form.Group className="mt-2">
                                <Form.Label>Reason</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    required
                                    value={adjustData.reason}
                                    onChange={(e) => setAdjustData({ ...adjustData, reason: e.target.value })}
                                />
                            </Form.Group>

                            <Button variant="success" type="submit" className="mt-3">
                                Confirm Adjustment
                            </Button>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>

            {/* Add Unit of Measure Modal */}
            <Modal show={showUnitModal} onHide={() => setShowUnitModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add New Unit of Measure</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleAddUnit}>
                        <Form.Group>
                            <Form.Label>Unit Name</Form.Label>
                            <Form.Control type="text" placeholder="Unit Name" required
                                          name="name" value={newUnit.name}
                                          onChange={(e) => setNewUnit({...newUnit, name: e.target.value})} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Abbreviation</Form.Label>
                            <Form.Control type="text" placeholder="Abbreviation" required
                                          name="abbreviation" value={newUnit.abbreviation}
                                          onChange={(e) => setNewUnit({...newUnit, abbreviation: e.target.value})} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Conversion Factor</Form.Label>
                            <Form.Control type="number" placeholder="Conversion Factor" required
                                          name="conversion_factor" value={newUnit.conversion_factor}
                                          onChange={(e) => setNewUnit({...newUnit, conversion_factor: parseFloat(e.target.value)})} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Base Unit</Form.Label>
                            <Form.Control as="select" value={newUnit.base_unit}
                                          onChange={(e) => setNewUnit({...newUnit, base_unit: e.target.value})}>
                                <option value="">Select Base Unit</option>
                                {unitsOfMeasure.map(unit => (
                                    <option key={unit.id} value={unit.id}>{unit.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Button variant="success" type="submit" className="mt-3">Save</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Edit Unit of Measure Modal */}
            <Modal show={showEditUnitModal} onHide={() => setShowEditUnitModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Unit of Measure</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {currentUnit && (
                        <Form onSubmit={handleUpdateUnit}>
                            <Form.Group>
                                <Form.Label>Unit Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentUnit.name}
                                    onChange={(e) => setCurrentUnit({...currentUnit, name: e.target.value})}
                                    required
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Abbreviation</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={currentUnit.abbreviation}
                                    onChange={(e) => setCurrentUnit({...currentUnit, abbreviation: e.target.value})}
                                    required
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Conversion Factor</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={currentUnit.conversion_factor}
                                    onChange={(e) => setCurrentUnit({...currentUnit, conversion_factor: parseFloat(e.target.value)})}
                                    required
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Base Unit</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={currentUnit.base_unit || ''}
                                    onChange={(e) => setCurrentUnit({...currentUnit, base_unit: e.target.value})}
                                >
                                    <option value="">Select Base Unit</option>
                                    {unitsOfMeasure.map(unit => (
                                        <option key={unit.id} value={unit.id}>{unit.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Button variant="success" type="submit" className="mt-3">Update</Button>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>

            {/*Add New Product*/}
            <Modal show={showModal} onHide={handleHideModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Add New Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formProductName">
                            {/* controlId is primarily for accessibility. It helps screen readers correctly associate
                            labels with form controls. Particularly useful for users with disabilities */}
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="product_name"
                                value={newProduct.product_name}
                                placeholder="Product Name"
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formDescription" className="mt-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="description"
                                value={newProduct.description}
                                placeholder="Description"
                                onChange={handleInputChange} />
                        </Form.Group>

                        <Form.Text className="text-muted mt-3 d-block">
                            Cost price and opening stock will start at zero and be established from purchases.
                        </Form.Text>

                        <Form.Group controlId="formRetailPrice" className="mt-3">
                            <Form.Label>Retail Price</Form.Label>
                            <Form.Control
                                type="number"
                                name="retail_price"
                                value={newProduct.retail_price}
                                placeholder="Retail Price"
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formWholesalePrice" className="mt-3">
                            <Form.Label>Wholesale Price</Form.Label>
                            <Form.Control
                                type="number"
                                name="wholesale_price"
                                value={newProduct.wholesale_price}
                                placeholder="Wholesale Price"
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formQuantityDiscountActive" className="mt-3">
                            <Form.Label>Quantity Discount</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="Enable automatic quantity discount"
                                name="quantity_discount_is_active"
                                checked={newProduct.quantity_discount_is_active}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <Row className="mt-2">
                            <Col md={6}>
                                <Form.Group controlId="formQuantityDiscountThreshold">
                                    <Form.Label>Minimum Quantity</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        name="quantity_discount_threshold"
                                        value={newProduct.quantity_discount_threshold}
                                        placeholder="Qty needed, e.g. 12"
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formQuantityDiscountAmount">
                                    <Form.Label>Discount Per Base Unit</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        name="quantity_discount_amount"
                                        value={newProduct.quantity_discount_amount}
                                        placeholder="Amount off, e.g. 5"
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group controlId="formIsVatApplicable" className="mt-3">
                            <Form.Label>VAT (16%)</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="Is VAT Applicable"
                                name="is_vat_applicable"
                                checked={newProduct.is_vat_applicable}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="formIsActive" className="mt-3">
                            <Form.Label>Active</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="Is Active"
                                name="is_active"
                                checked={newProduct.is_active}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="formReorderLevel" className="mt-3">
                            <Form.Label>Reorder Level</Form.Label>
                            <Form.Control
                                type="number"
                                name="reorder_level"
                                value={newProduct.reorder_level}
                                placeholder="Low stock threshold"
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Category</Form.Label>
                            <Form.Control
                                as="select"
                                name="category"
                                onChange={handleInputChange}
                                value={newProduct.category}>
                                <option value="">Select Category</option>
                                {categories.map(category => (
                                    <option key={category.id} value={category.id}>{category.category_name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>

                        {/* Units of measure */}
                        <Form.Group className="mt-3">
                            <Form.Label>Base Unit</Form.Label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Form.Control
                                as="select"
                                name="base_unit"
                                onChange={handleInputChange}
                                value={newProduct.base_unit}
                                required = {newProduct.has_alternative_units} // make it conditionally required
                            >
                                <option value="">Select Base Unit</option>
                                {unitsOfMeasure.map(unit => (
                                    <option key={unit.id} value={unit.id}>{unit.name}</option>
                                ))}
                            </Form.Control>
                            <Button variant="link" onClick={() => setShowUnitModal(true)} className="ml-2">
                                + Add Unit
                            </Button>
                            </div>
                        </Form.Group>

                        <Form.Group controlId="formHasAlternativeUnits" className="mt-3">
                            <Form.Check
                                type="checkbox"
                                label="Has Alternative Units"
                                name="has_alternative_units"
                                checked={newProduct.has_alternative_units}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        {/* alternative units */}
                        {newProduct.has_alternative_units && (
                            <div className="mt-3">
                                <h5>Alternative Units</h5>
                                {newProduct.alternative_units.map((unit, index) => (
                                    <div key={index} className="border p-2 mb-2">
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Unit</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        value={unit.unit || ''}
                                                        onChange={(e) => handleAlternativeUnitChange(index, 'unit', e.target.value, false)}
                                                    >
                                                        <option value="">Select Unit</option>
                                                        {unitsOfMeasure.map(uom => (
                                                            <option key={uom.id} value={uom.id}>{uom.name}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Conversion Factor</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={unit.conversion_factor !== undefined? unit.conversion_factor : ''}
                                                        onChange={(e) => handleAlternativeUnitChange(index, 'conversion_factor', e.target.value, false)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Unit Cost Price</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={unit.unit_cost_price !== undefined && unit.unit_cost_price !== null ? unit.unit_cost_price : ''}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Unit Price</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={unit.unit_price !== undefined && unit.unit_price !== null ? unit.unit_price : ''}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Wholesale Price</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={unit.unit_wholesale_price !== undefined && unit.unit_wholesale_price !== null ? unit.unit_wholesale_price : ''}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs="auto" className="d-flex align-items-center">
                                                <Button variant="danger" onClick={() => handleRemoveAlternativeUnit(index, false)}>Remove</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                                <Button variant="secondary" onClick={() => handleAddAlternativeUnit(false)}>Add Alternative Unit</Button>
                            </div>
                        )}
                        <Button variant="success" type="submit" className="mt-3">Add Product</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {showEditModal && (
                <Modal show={showEditModal} onHide={handleHideEditModal} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Product</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleUpdateProduct}>
                            <Form.Group>
                                <Form.Label>Product Name</Form.Label>
                                <Form.Control type="text" placeholder="Product Name" required
                                              name="product_name" value={currentProduct.product_name}
                                              onChange={handleEditInputChange} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Description</Form.Label>
                                <Form.Control as="textarea" rows={3} placeholder="Description"
                                              name="description" value={currentProduct.description}
                                              onChange={handleEditInputChange} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Cost Price</Form.Label>
                                <Form.Control type="number" placeholder="Cost Price" required
                                              name="cost_price" value={currentProduct.cost_price}
                                              onChange={handleEditInputChange} />
                            </Form.Group>

                            {/*<Form.Group>*/}
                            {/*    <Form.Label>Stock</Form.Label>*/}
                            {/*    <Form.Control type="number" placeholder="Stock" required*/}
                            {/*                  name="stock" value={currentProduct.stock}*/}
                            {/*                  onChange={handleEditInputChange} />*/}
                            {/*</Form.Group>*/}

                            {/*<Button variant="warning" className="mt-3" onClick={() => {*/}
                            {/*    setAdjustProduct(currentProduct); setShowEditModal(false); setShowAdjustModal(true); }}*/}
                            {/*        >Adjust Stock*/}
                            {/*</Button>*/}

                            <Form.Group>
                                <Form.Label>Retail Price</Form.Label>
                                <Form.Control type="number" placeholder="Retail Price" required
                                              name="retail_price" value={currentProduct.retail_price}
                                              onChange={handleEditInputChange} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Wholesale Price</Form.Label>
                                <Form.Control type="number" placeholder="Wholesale Price" required
                                              name="wholesale_price" value={currentProduct.wholesale_price}
                                              onChange={handleEditInputChange} />
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>Quantity Discount</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    label="Enable automatic quantity discount"
                                    name="quantity_discount_is_active"
                                    checked={!!currentProduct.quantity_discount_is_active}
                                    onChange={handleEditInputChange}
                                />
                            </Form.Group>

                            <Row className="mt-2">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Minimum Quantity</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            placeholder="Qty needed, e.g. 12"
                                            name="quantity_discount_threshold"
                                            value={currentProduct.quantity_discount_threshold || ''}
                                            onChange={handleEditInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Discount Per Base Unit</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            placeholder="Amount off, e.g. 5"
                                            name="quantity_discount_amount"
                                            value={currentProduct.quantity_discount_amount || ''}
                                            onChange={handleEditInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group>
                                <Form.Label>VAT (16%)</Form.Label>
                                <Form.Check type="checkbox" label="Is VAT Applicable" name="is_vat_applicable"
                                            checked={currentProduct.is_vat_applicable} onChange={handleEditInputChange} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Active</Form.Label>
                                <Form.Check type="checkbox" label="Is Active" name="is_active"
                                            checked={currentProduct.is_active} onChange={handleEditInputChange} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Reorder Level</Form.Label>
                                <Form.Control type="number" placeholder="Low stock threshold" required
                                                name="reorder_level" value={currentProduct.reorder_level}
                                                onChange={handleEditInputChange} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Category</Form.Label>
                                <Form.Control as="select" name="category" onChange={handleEditInputChange}
                                              value={currentProduct.category}>
                                    <option value="">Select Category</option>
                                    {categories.map(category => (
                                        <option key={category.id} value={category.id}>{category.category_name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            {/*unit of measure*/}
                            <Form.Group className="mt-3">
                                <Form.Label>Base Unit</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="base_unit"
                                    onChange={handleEditInputChange}
                                    value={currentProduct.base_unit}
                                    required = {currentProduct.has_alternative_units} // make it conditionally required
                                >
                                    <option value="">Select Base Unit</option>
                                    {unitsOfMeasure.map(unit => (
                                        <option key={unit.id} value={unit.id}>{unit.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group controlId="formHasAlternativeUnits" className="mt-3">
                                <Form.Check
                                    type="checkbox"
                                    label="Has Alternative Units"
                                    name="has_alternative_units"
                                    checked={currentProduct.has_alternative_units}
                                    onChange={handleEditInputChange}
                                />
                            </Form.Group>

                            {/* alternative units */}
                            {currentProduct.has_alternative_units && (
                                <div className="mt-3">
                                    <h5>Alternative Units</h5>
                                    {currentProduct.alternative_units.map((unit, index) => (
                                        <div key={index} className="border p-2 mb-2">
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Unit</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            value={unit.unit || ''}
                                                            onChange={(e) => handleAlternativeUnitChange(index, 'unit', e.target.value, true)}
                                                        >
                                                            <option value="">Select Unit</option>
                                                            {unitsOfMeasure.map(uom => (
                                                                <option key={uom.id} value={uom.id}>{uom.name}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Conversion Factor</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            // value={unit.conversion_factor}
                                                            value={unit.conversion_factor !== undefined ? unit.conversion_factor : ''}
                                                            onChange={(e) => handleAlternativeUnitChange(index, 'conversion_factor', e.target.value, true)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Unit Cost Price</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={unit.unit_cost_price !== undefined ? unit.unit_cost_price : ''}
                                                            readOnly
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Unit Price</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={unit.unit_price !== undefined ? unit.unit_price : ''}
                                                            readOnly
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Wholesale Price</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={unit.unit_wholesale_price !== undefined ? unit.unit_wholesale_price : ''}
                                                            readOnly
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs="auto" className="d-flex align-items-center">
                                                    <Button
                                                        variant="danger"
                                                        onClick={() => handleRemoveAlternativeUnit(index, true)}>Remove
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                    <Button variant="secondary" onClick={() => handleAddAlternativeUnit(true)}>Add Alternative Unit</Button>
                                </div>
                            )}

                            <hr/>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                    <strong>Current Stock:</strong> {currentProduct.stock}
                                </div>

                                <Button variant="warning" className="mt-3" onClick={() => {
                                    setAdjustProduct(currentProduct); setShowEditModal(false); setShowAdjustModal(true); }}
                                        >Adjust Stock</Button>
                            </div>
                            <Button variant="success" type="submit" className="mt-3">Update</Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}

            {showCategoryModal && (
                <Modal show={showCategoryModal} onHide={handleCloseCategoryModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Add New Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleAddCategory}>
                            <Form.Group>
                                <Form.Label>Category Name</Form.Label>
                                <Form.Control type="text" placeholder="Category Name" required
                                              name="category_name" value={newCategory.category_name}
                                              onChange={(e) => setNewCategory({...newCategory, category_name: e.target.value})} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Description</Form.Label>
                                <Form.Control as="textarea" rows={3} placeholder="Description"
                                              name="description" value={newCategory.description}
                                              onChange={(e) => setNewCategory({...newCategory, description: e.target.value})} />
                            </Form.Group>
                            <Button variant="success" type="submit" className="mt-3">Save</Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}

            {showCategoryList && (
                <Modal show={showCategoryList} onHide={handleCloseCategoryList} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Categories</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table striped bordered hover responsive>
                            <thead>
                            <tr>
                                <th>Category Name</th>
                                <th>Description</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {categories.map(category => (
                                <tr key={category.id}>
                                    <td>{category.category_name}</td>
                                    <td>{category.description}</td>
                                    <td>
                                        <Button variant="success" onClick={() => handleEditCategoryClick(category)}
                                        className="button-spacing">Edit</Button>
                                        <Button variant="danger" onClick={() => handleDeleteCategoryClick(category.id)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
            )}
           {/*edit category modal */}
            { showEditCategoryModal && editCategory && (
                <Modal show={showEditCategoryModal} onHide={handleCloseEditCategoryModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleUpdateCategory}>
                            <Form.Group>
                                <Form.Label>Category Name</Form.Label>
                                <Form.Control type="text" placeholder="Category Name" required
                                              name="category_name" value={editCategory.category_name}
                                              onChange={(e) => setEditCategory({...editCategory, category_name: e.target.value})} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Description</Form.Label>
                                <Form.Control as="textarea" rows={3} placeholder="Description"
                                              name="description" value={editCategory.description}
                                              onChange={(e) => setEditCategory({...editCategory, description: e.target.value})} />
                            </Form.Group>
                            <Button variant="success" type="submit" className="mt-3">Update</Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}
            {/*units list modal*/}
            <Modal show={showUnitList} onHide={() => setShowUnitList(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Units of Measure</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button variant="primary" onClick={() => setShowUnitModal(true)} className="mb-3">Add New Unit</Button>
                    <Table striped bordered hover responsive className="mt-3">
                        <thead>
                        <tr>
                            <th>Unit Name</th>
                            <th>Abbreviation</th>
                            <th>Conversion Factor</th>
                            <th>Base Unit</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            {unitsOfMeasure.map(unit => (
                                <tr key={unit.id}>
                                    <td>{unit.name}</td>
                                    <td>{unit.abbreviation}</td>
                                    <td>{unit.conversion_factor}</td>
                                    <td>{unit.base_unit_details ? unit.base_unit_details.name : 'None'}</td>
                                    <td>
                                        <Button variant="success" className="button-spacing" onClick={() => handleEditUnit(unit)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </Button>
                                        <Button variant="danger" onClick={() => handleDeleteUnit(unit.id)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Product;